import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { H1 } from '#/components/Text/H1';
import { PostSearchInputContainer } from '#/containers/PostSearchInputContainer';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';

import {
  ArticleHeroBackgroundHolder,
  ArticleHeroBackgroundImageHolder,
  ArticleSearchHero_Box_1,
  ArticleSearchHeroContainer,
  ArticleSearchHeroTitle,
  ArticleSearchHeroWrapper,
} from './ArticleSearchHero.styled';

type Props = {
  content: CmsApiDocument;
  title?: string;
  image: ApiFilestackImageData | null | undefined;
  imageMobile: ApiFilestackImageData | null | undefined;
};

export function ArticleSearchHero({
  content,
  title,
  image,
  imageMobile,
}: Props) {
  const { i18n } = useI18n();
  const { subsite } = content;

  // search is only available when there's a home page
  const homePage = subsite.homePage!;
  const heroImage = image;
  const mobileHeroImage = imageMobile;

  return (
    <ArticleSearchHero_Box_1 data-qa-id="article-search-hero">
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        {(heroImage ?? mobileHeroImage) && (
          <ArticleHeroBackgroundHolder>
            <ArticleHeroBackgroundImageHolder>
              <FilestackImage
                qaId="hero-image-image"
                width={1920}
                height={1024}
                expandSize
                objectFit="cover"
                alt={i18n('Hero image')}
                data={heroImage ?? mobileHeroImage ?? null}
                mobileData={mobileHeroImage ?? undefined}
                mobileAspectRatio={{ width: 414, height: 470 }}
                style={{ height: '100%' }}
              />
            </ArticleHeroBackgroundImageHolder>
          </ArticleHeroBackgroundHolder>
        )}
      </div>

      <div
        style={{
          position: 'relative',
          transform: 'rotateZ(0)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <ArticleSearchHeroContainer>
          <ArticleSearchHeroWrapper>
            <div style={{ marginBottom: 24 }}>
              <H1>
                <ArticleSearchHeroTitle
                  style={{ lineHeight: 1.3 }}
                  dangerouslySetInnerHTML={{
                    // @ts-expect-error TS(2769): No overload matches this call.
                    __html: title?.replace(/<(\/?)(p|h1)>/g, '<$1span>'),
                  }}
                />
              </H1>
            </div>
            <PostSearchInputContainer
              homePageUrl={homePage.url}
              searchPlaceholderText={subsite.searchPlaceholderText}
              usageContext="searchHero"
            />
          </ArticleSearchHeroWrapper>
        </ArticleSearchHeroContainer>
      </div>
    </ArticleSearchHero_Box_1>
  );
}
